














import { Component, Vue, Prop } from 'vue-property-decorator'
import { namespace } from 'vuex-class'
import { Company, EditCompany, AddCompany } from '../store/company'
import CompanyForm from './CompanyForm.vue'
const company = namespace('company')

@Component({ components: { CompanyForm } })
export default class EditCompanyView extends Vue {
  @company.Action editCompany!: (company: EditCompany) => Promise<Company>
  @Prop() company!: Company
  dialog = false
  async edit(input: AddCompany) {
    const id = this.company.id
    await this.editCompany({ id, ...input })
    this.dialog = false
    this.$emit('done')
  }
}
